import maplibregl from 'maplibre-gl';
import { Protocol } from 'pmtiles';

// Protocolo pmtiles:// de MapLibre para Kairos, registrado una sola vez (antes lo registraban map-container y map_left
// por separado y ganaba el último importado).
// Las teselas raster que faltan en el archivo (vacías: p. ej. sin convección en toda la tesela) llegan con data null y
// MapLibre no las da nunca por cargadas: el mapa no llega a idle ni a loaded() y, al cambiar de hora, esa tesela se
// queda con la imagen de la hora anterior. Se cambian por una tesela transparente de 1 px
const protocol = new Protocol();
maplibregl.addProtocol('pmtiles', async (params, abortController) => {
  const response = await protocol.tile(params, abortController);
  return response.data === null ? { data: await createImageBitmap(new ImageData(1, 1)) } : response;
});
